import React from 'react';
import { NotesEntityFields } from 'common/graphql/__generated__/NotesEntityFields';
import {
  NotePayCycleCreate,
  NotePayCycleCreateVariables,
} from './__generated__/NotePayCycleCreate';
import { NotesSectionProps } from 'common/components/NotesSection';
import { GenericNotesSection } from 'common/components/ActionMenu/Notes';

import NOTE_PAY_CYCLE_CREATE from './NotePayCycleCreate.graphql';

type PayCycleNotesProps = Pick<NotesSectionProps, 'listRefreshRequest'> & {
  payCycleId: string;
  data: NotesEntityFields[];
  loading?: boolean;
};

export const PayCycleNotesSection: React.FC<PayCycleNotesProps> = ({
  payCycleId,
  data,
  loading,
  listRefreshRequest,
}) => {
  return (
    <GenericNotesSection<
      any,
      NotePayCycleCreate, // TMutationResult
      NotePayCycleCreateVariables // TMutationVariables
    >
      entityId={payCycleId}
      data={data}
      loading={loading}
      mutationDocument={NOTE_PAY_CYCLE_CREATE}
      listRefreshRequest={listRefreshRequest}
    />
  );
};
